import React, { FC } from 'react'
import { useReactiveVar } from '@apollo/client'

import { UpcomingTours } from 'modules/Feed/components'
import useGetUpcomingTours from 'modules/Feed/serviceHooks/useGetUpcomingTours'
import { useZoneMenu } from 'modulesCommon/serviceHooks'
import { labelTitleVar } from 'modulesCommon/store'

const UpcomingToursContainer: FC = () => {
  const { currentSpace } = useZoneMenu()
  const currentLabelTitle = useReactiveVar(labelTitleVar)

  const { upcomingTours } = useGetUpcomingTours()

  if ((!currentSpace?.name && !currentLabelTitle) || !upcomingTours?.length) {
    return null
  }

  return (
    <UpcomingTours
      title={currentSpace?.name || currentLabelTitle}
      /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
      // @ts-ignore
      upcomingTours={upcomingTours}
      isSpace={!!currentSpace}
    />
  )
}

export default UpcomingToursContainer
